export default class SingleDaf {
    constructor() {
        this.downloadButton = document.getElementById('daf-download');
        this.addEvents();
    }

    handleDownloadClick(e) {
        e.preventDefault();

        let postId =  this.getPostId();

        if (!postId) {
            // Try global variable
            if (typeof window.currentPostId !== 'undefined') {
                postId = window.currentPostId;
            } else {
                // Try canonical link
                const canonicalLink = document.querySelector('link[rel="canonical"]')?.href;
                if (canonicalLink) {
                    const urlParts = canonicalLink.split('/');
                    for (let i = urlParts.length - 1; i >= 0; i--) {
                        if (/^\d+$/.test(urlParts[i])) {
                            postId = urlParts[i];
                            break;
                        }
                    }
                }

                // Try body class
                if (!postId) {
                    const bodyClasses = document.body.className.split(' ');
                    const postidClass = bodyClasses.find(cls => cls.startsWith('postid-'));
                    if (postidClass) {
                        postId = postidClass.replace('postid-', '');
                    }
                }
            }
        }

        if (!postId) {
            alert('Could not determine post ID. Please try again.');
            return;
        }

        // Save original button state
        const originalHtml = this.downloadButton.innerHTML;

        // Set loading state
        this.downloadButton.innerHTML = `<span class="loading-text">${AssetsPath.translations.preparingDownload}</span> <span class="loading-dots"></span>`;
        this.downloadButton.disabled = true;
        this.downloadButton.classList.add('loading');

        // Animate loading dots
        let dotsCount = 0;
        const loadingInterval = setInterval(() => {
            dotsCount = (dotsCount + 1) % 4;
            const dots = '.'.repeat(dotsCount);
            this.downloadButton.querySelector('.loading-dots').textContent = dots;
        }, 300);

        // Extract Sefaria content
        const sefariaContent = extractSefariaContent();

        // Make the AJAX request
        const formData = new FormData();
        formData.append('action', 'download_daf_content');
        formData.append('post_id', postId);
        if (Object.keys(sefariaContent).length) {
            formData.append('sefaria_content', JSON.stringify(sefariaContent));
        }

        fetch(myAjax.ajaxurl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(response => {
                if (response.success && response.data?.title && response.data?.content) {
                    const instance = new SingleDaf();
                    instance.downloadContent(response.data.title, response.data.content);
                } else {
                    console.error('Error in response:', response);
                    if (response.data?.message) {
                        console.error('Error message:', response.data.message);
                        if (response.data.trace) {
                            console.error('Error trace:', response.data.trace);
                        }
                        alert('Error: ' + response.data.message);
                    } else {
                        alert('Error preparing content for download. Please check the console for details.');
                    }
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
                alert('Error preparing content for download. Please check the console for details.');
            })
            .finally(() => {
                // Reset button state
                clearInterval(loadingInterval);
                this.downloadButton.innerHTML = originalHtml;
                this.downloadButton.disabled = false;
                this.downloadButton.classList.remove('loading');
            });

        // Helper function to extract Sefaria content
        function extractSefariaContent() {
            const content = {};
            try {
                const sefariaSection = document.querySelector('.daf_sefaria');
                if (!sefariaSection) return content;

                content.html = sefariaSection.innerHTML;

                const heTexts = [];
                const enTexts = [];

                // Get Hebrew texts
                document.querySelectorAll('.daf_sefaria__text.he').forEach(el => {
                    heTexts.push(el.innerHTML);
                });

                // Get English texts
                document.querySelectorAll('.daf_sefaria__text.en').forEach(el => {
                    enTexts.push(el.innerHTML);
                });

                // Try alternative selectors if needed
                if (!heTexts.length || !enTexts.length) {
                    document.querySelectorAll('.daf_sefaria p.he, .daf_sefaria .he').forEach(el => {
                        heTexts.push(el.innerHTML);
                    });

                    document.querySelectorAll('.daf_sefaria p.en, .daf_sefaria .en').forEach(el => {
                        enTexts.push(el.innerHTML);
                    });
                }

                if (heTexts.length && enTexts.length) {
                    content.hebrew = heTexts;
                    content.english = enTexts;
                }
            } catch (e) {
                console.error('Error extracting Sefaria content:', e);
            }
            return content;
        }
    }

    getPostId() {
        const globalPostId = window.currentPostId ?? window.post_id ?? null;
        if (globalPostId) return globalPostId;

        const canonicalHref = document.querySelector('link[rel="canonical"]')?.href;
        if (canonicalHref) {
            const numericId = canonicalHref.split('/')
                .reverse()
                .find(part => /^\d+$/.test(part));

            if (numericId) return numericId;
        }

        const postIdClass = document.body.className.split(' ')
            .find(className => className.startsWith('postid-'));

        if (postIdClass) {
            return postIdClass.replace('postid-', '');
        }

        return null;
    };

    addEvents() {
        if (window.dafDownloadEventsAdded) {
            return;
        }

        var ajaxurl = myAjax.ajaxurl;

        $('.start_masechet:not(.only-registered)').on('click', function (e){
            e.preventDefault();
            let id = $(this).attr('data-id');
            let slug = $(this).attr('data-slug');
            jQuery.ajax({
                type: 'POST',
                url: ajaxurl,
                data: {
                    "action": "start_masechet",
                    'id_page': id,
                    'slug': slug,
                },
                success: function (response) {
                    let firstDaf = $('.daf_learn__list>.daf-card:first-child');
                    if(firstDaf){
                        window.location = firstDaf.find('.daf-card__header').attr('href');
                    }else {
                        window.location.reload();
                    }
                }
            });
        });

        if (this.downloadButton) {
            this.downloadButton.addEventListener('click', this.handleDownloadClick.bind(this));
        } else {
            console.warn('Daf download button not found');
        }

        window.dafDownloadEventsAdded = true;
    }

    downloadContent(title, content) {
        try {
            const safeFilename = `${title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.html`;
            
            if (content.length > 2000000) {
                this.downloadWithBlob(content, safeFilename);
            } else {
                this.downloadWithDataUrl(content, safeFilename);
            }
        } catch (error) {
            console.error('Error downloading content:', error);
            alert('There was an error downloading the content. Please try again.');
        }
    }

    downloadWithBlob(content, filename) {
        const blob = new Blob([content], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        this.triggerDownload(url, filename);
        
        // Clean up the blob URL after download
        setTimeout(() => URL.revokeObjectURL(url), 100);
    }

    downloadWithDataUrl(content, filename) {
        const dataUrl = `data:text/html;charset=utf-8,${encodeURIComponent(content)}`;
        this.triggerDownload(dataUrl, filename);
    }

    triggerDownload(url, filename) {
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        
        // Remove the element after download starts
        setTimeout(() => document.body.removeChild(a), 100);
    }
}